export default "__VITE_ASSET__n6cCL7E___"